module.exports = __webpack_public_path__ + "img/404.b530c8a7.png";